import { memo } from "react";

import "@fontsource/inter";
import Layout from "./layouts/Layout.tsx";
import { MainRouter } from "./router/MainRouter";
import Header from "./pages/header/index.tsx";

const App = () => {
  return (
    <Layout>
      <Header />
      <MainRouter />
    </Layout>
  );
};

export default memo(App);
